import { AudioManager, useDown } from "@aircall/tractor";

import { DataAccessLayer } from "@/components/DataAccessLayer/DataAccessLayer";
import { DesktopLayout } from "@/components/DesktopLayout/DesktopLayout";
import { MobileLayout } from "@/components/MobileLayout/MobileLayout";
import { AudioProvider } from "@/providers/AudioContext";

function PickContent() {
  const isDownMd = useDown("md");

  if (isDownMd) {
    return <MobileLayout />;
  }

  return <DesktopLayout />;
}

export function Assets() {
  return (
    <AudioManager>
      <DataAccessLayer>
        <AudioProvider>
          <PickContent />
        </AudioProvider>
      </DataAccessLayer>
    </AudioManager>
  );
}
